import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup } from 'reactstrap';
import { Utils } from '../../services';

import './LanguageSelector.css';

const LanguageSelector = ({ onChange, value, languages }) => {
    const available_languages = languages?.length ? languages : Utils.langs();
    const resolve_language = (lang) => (
        lang && available_languages.includes(lang) ? lang : available_languages[0]
    );
    const [current, setCurrent] = useState(() => resolve_language(value));

    useEffect(() => {
        if (value !== undefined) {
            setCurrent(resolve_language(value));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);

    useEffect(() => {
        if (value === undefined) {
            onChange(current);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const select_language = (lang) => {
        setCurrent(lang);
        onChange(lang);
    };

    return (
        <ButtonGroup className="LanguageSelector">
        {available_languages.length > 1 && available_languages.map((l) => (
            <Button key={l} size="sm" onClick={(_e) => { select_language(l); }} className="lang-switcher" color={current === l ? "primary" : "dark"}>
                {l.toUpperCase()}
            </Button>
        ))}
        </ButtonGroup>
    );
}

export default LanguageSelector;
